import { useMemo } from 'react'
import {
  getScopesFromAuthorizationUrl,
  idealPermissions,
  permissionToScope,
  type PermissionType,
} from './permissions'

export function useIdealPermissionsFromAuthorizationUrl(
  authorizationUrl: string | null,
): PermissionType[] {
  return useMemo(() => {
    if (!authorizationUrl) {
      return [...idealPermissions]
    }
    const requestedScopes = getScopesFromAuthorizationUrl(authorizationUrl)
    if (requestedScopes.length === 0) {
      return [...idealPermissions]
    }
    const scopeSet = new Set(requestedScopes)
    return idealPermissions.filter((permission) =>
      scopeSet.has(permissionToScope[permission]),
    )
  }, [authorizationUrl])
}
